import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Grid } from '@mui/material';
import {
  SiteReviewValue,
  boldFont,
  popupInformationGrid,
  popupTitle,
} from '../../../styles';

//Component to show the Popup on Site Owner & Site Review page to pick the department head
const Popup = props => {
  const { t } = useTranslation();
  const {
    title,
    department,
    children,
    open,
    // handleClose,
    popupHeader = t('PECR_Site_Department_Selection'),
  } = props;

  //custom style for Modal box
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  return (
    <div>
      <Modal
        open={open}
        // onClose={handleClose} //onBackDrop
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={style}>
          <Typography style={popupTitle}>{popupHeader}</Typography>
          <Grid style={popupInformationGrid}>
            <Grid style={boldFont}>{`${t('Title')}:`}</Grid>
            <Grid style={SiteReviewValue}>{title}</Grid>
          </Grid>
          <Grid style={popupInformationGrid}>
            <Grid style={boldFont}>{`${t('Department')}:`}</Grid>
            <Grid style={SiteReviewValue}>{department}</Grid>
          </Grid>
          {children}
        </Box>
      </Modal>
    </div>
  );
};

export default Popup;
